(function(){
  // Scope: nur innerhalb dieses Snippet-Containers arbeiten
  var root = document.querySelector('.vo-sn-la');
  if (!root) return;

  var form = root.querySelector('#vo-sn-la-form');
  var bar  = root.querySelector('.vo-chipbar');
  if (!form || !bar) {
    console.warn('VO Chips: Form oder Chipbar nicht gefunden.');
    return;
  }

  // Alle Fragenzeilen (in deinem Snippet sind das die Labels mit .vo-sn-row, Q1..Q52)
  var rows = Array.prototype.slice.call(form.querySelectorAll('.vo-sn-row'));

  // Gruppen-Mapping (Frage-Nummern sind 1-basiert, Reihenfolge = DOM-Reihenfolge)
  var groups = {
    alle:       null,
    frau:       [6,22],
    mann:       [22],
    energie:    [1,18,28,29,31,32,35,38,40,47],
    ernaehrung: [4,5,10,15,19,27,30,34,39,42,48],
    haut:       [11,17,24,25,26,36,49],
    balance:    [2,3,7,8,12,14,22,23,37,41,43,44],
    psyche:     [9,13,16,20,21,33,45,46]
  };

  function applyFilter(key){
    var list = groups[key] || null;
    rows.forEach(function(row, idx){
      var qNum = idx + 1;          // 1..52
      var isContact = qNum >= 50;  // 50–52: Kontaktdaten immer zeigen
      if (isContact || !list) {
        row.style.display = '';
      } else {
        row.style.display = list.indexOf(qNum) !== -1 ? '' : 'none';
      }
    });
  }

  // Click-Delegation auf die Chipbar
  bar.addEventListener('click', function(e){
    var btn = e.target.closest('button[data-chip]');
    if (!btn) return;
    // Active-Style umschalten
    bar.querySelectorAll('button').forEach(function(b){ b.classList.remove('is-active'); });
    btn.classList.add('is-active');
    // Filtern
    applyFilter(btn.getAttribute('data-chip'));
  });

  // Initialzustand
  applyFilter('alle');
})();